import { fetchApi } from '@/config/axiosSetting';
import { patchVisitInformationParams } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchVisitInformation/patchVisitInformationQuery.type';

export const patchInitialVisitInformationFunction = (
  params: patchVisitInformationParams,
) => {
  return fetchApi.patch(
    `/initial/reports/${params.id}/adjusting/visit_information/`,
    {
      ...params?.data,
    },
    {
      params: {
        id: params?.id,
      },
    },
  );
};
